import { render, staticRenderFns } from "./modifyAutoLevel.vue?vue&type=template&id=768e0f11"
import script from "./modifyAutoLevel.vue?vue&type=script&lang=js"
export * from "./modifyAutoLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports